module.exports = __webpack_public_path__ + "static/media/logo1.3fb5b053.png";